import { render, staticRenderFns } from "./Encounter.vue?vue&type=template&id=fe6c2baa&"
import script from "./Encounter.vue?vue&type=script&lang=ts&"
export * from "./Encounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports